module.exports = "https://cdn.hellotech.com/client-assets/walmart-header-logo-white_736d72e9d3ef19c1d13d5caacea32f6b.svg";